import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Skeleton} from '../../../../../libs/shared/ui/src/components/utility/skeleton';
import {GifModel, GiphyRenditionsEnum} from '../../../../models/api/gifModel';
import {thumbnailSquareSize} from './gifDropdownCommons';

/*
 * Props.
 */

interface GifDropdownListItemProps {
  gif?: GifModel;
  onSelect?: () => void;
}

/*
 * Styles.
 */

const StyledPlaceholderSkeleton = styled(Skeleton)`
  ${addGridItemStyles()}
`;

const StyledImage = styled.img`
  object-fit: cover;
  background-color: ${(p) => p.theme.greys.shade30};
  ${addGridItemStyles()}
`;

function addGridItemStyles() {
  return css`
    border-radius: 4px;

    width: ${thumbnailSquareSize}px;
    height: ${thumbnailSquareSize}px;
  `;
}

/*
 * Component.
 */

export const GifDropdownListItem: FC<GifDropdownListItemProps> = ({gif, onSelect}) => {
  // If gif is not defined, we should render a placeholder.
  if (!gif) {
    return <StyledPlaceholderSkeleton />;
  }

  const {url} = gif.images[GiphyRenditionsEnum.FIXED_WIDTH];

  return (
    <ChromelessButton key={url} onClick={onSelect}>
      <StyledImage src={url} />
    </ChromelessButton>
  );
};
